<template>
  <div class="etms-router-body">
    <div class="etms-router-search">
      <span class="etms-router-search-label fl">渠道：</span>
      <el-select size="mini" placeholder="选择渠道搜索" v-model="search.ChannelId" class="etms-router-search-element fl" filterable clearable>
        <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">使用状态：</span>
      <el-select size="mini" v-model="search.State" class="etms-router-search-element fl" filterable clearable>
        <el-option v-for="item in constant.oddstates" :key="item.value" :value="item.value" :label="item.label"></el-option>
      </el-select>
      <span class="etms-router-search-label fl">单号：</span>
      <el-input size="mini" placeholder="填写单号搜索" class="etms-router-search-element fl" v-model="search.Odd"></el-input>
      <el-dropdown @command="handleCommand" class="etms-router-search-button fr">
        <el-button size="mini" type="primary">
          更多操作<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="deleteChannelOdd">删除号段</el-dropdown-item>
          <el-dropdown-item command="useChannelOdd">使用号段</el-dropdown-item>
          <el-dropdown-item command="recoveryChannelOdd">回收号段</el-dropdown-item>
          <el-dropdown-item command="importOddPool">导入号段</el-dropdown-item>
          <el-dropdown-item command="exportChannelOdd">导出号段</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-tooltip class="item" effect="dark" content="查询号段" placement="top">
        <el-button size="mini" @click="searchClick" class="etms-router-search-button fr" type="primary" icon="el-icon-search"></el-button>
      </el-tooltip>
      <div class="clear"></div>
    </div>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="search.pageindex" :page-sizes="constant.pagesizes" :page-size="search.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="search.recordcount"></el-pagination>
    <el-table :border="true" :data="oddlist" height="90%" @selection-change="handleSelectionChange" class="etms-router-list">
      <el-table-column type="selection" width="40px" header-align="center" align="center" prop="id">
      </el-table-column>
      <el-table-column label="序号" type="index" align="center"></el-table-column>
      <el-table-column label="渠道" prop="channelId" :formatter="formatterChannel"></el-table-column>
      <el-table-column label="单号" prop="odd"></el-table-column>
      <el-table-column label="状态" prop="state" :formatter="formatterState"></el-table-column>
    </el-table>
    <el-dialog :title="dialogtitle" :visible.sync="dialogvisible" center :modal-append-to-body="false" width="500px">
      <el-form ref="form" label-width="100px">
        <el-form-item label="渠道：">
          <el-select size="mini" placeholder="请选择渠道" v-model="form.ChannelId" class="el-width-200">
            <el-option v-for="item in channellist" :key="item.id" :value="item.id" :label="item.channelName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件：">
          <el-upload class="upload-demo" ref="upload" :action="constant.openPaths.importChannelOdd" :http-request="importChannelOdd" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :auto-upload="false" list-type="text">
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过2mb</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left:10px;" size="small" type="success" @click="submitUpload">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  data () {
    return {
      userinfo: this.$cookies.get('userinfo'),
      channellist: [],
      search: {
        pageindex: 1,
        pagesize: 100,
        recordcount: 0,
        ChannelId: '',
        State: '',
        Odd: '',
        Odds: []
      },
      oddlist: [],
      dialogtitle: '导入号段',
      dialogvisible: false,
      formname: 'branchesform',
      fileList: [],
      oddpoolids: [],
      form: {
        ChannelId: ''
      }
    }
  },
  mounted () {
    this.initChannelList()
    this.searchClick()
  },
  methods: {
    initChannelList () {
      var data = {
        UserId: this.userinfo.id,
        EnterpriseId: this.userinfo.enterpriseId,
        LoginToken: this.userinfo.loginToken
      }
      this.common.postAjaxRequest(this, this.constant.openPaths.getChannelList, data, 'channellist')
    },
    handleSelectionChange (val) {
      this.search.Odds = []
      val.forEach(item => {
        this.search.Odds.push(item.id)
      })
      console.log(this.search.Odds)
    },
    searchClick () {
      if (this.userinfo !== null && this.userinfo !== undefined) {
        var data = {
          UserId: this.userinfo.id,
          EnterpriseId: this.userinfo.enterpriseId,
          LoginToken: this.userinfo.loginToken,
          PageSize: this.search.pagesize,
          PageIndex: this.search.pageindex,
          ChannelId: this.search.ChannelId,
          Odd: this.search.Odd,
          State: this.search.State
        }
        var self = this
        this.$ajax.post(this.constant.openPaths.searchChannelOddPager, data).then(res => {
          switch (res.data.code) {
            case 200:
              self.oddlist = res.data.result.tList
              self.search.recordcount = res.data.result.recordCount
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        })
      }
    },
    handleSizeChange (val) {
      this.search.pagesize = val
      this.searchClick()
    },
    handleCurrentChange (val) {
      this.search.pageindex = val
      this.searchClick()
    },
    formatterChannel (row) {
      var channel = this.channellist.filter(item => item.id === row.channelId)[0]
      if (channel !== null && channel !== undefined) {
        return channel.channelName
      }
      return ''
    },
    formatterState (row) {
      var state = this.constant.oddstates.filter(item => item.value === row.state)[0]
      if (state !== null && state !== undefined) {
        return state.label
      }
      return ''
    },
    importChannelOdd (content) {
      let formData = new FormData()
      formData.append('UserId', this.userinfo.id)
      formData.append('EnterpriseId', this.userinfo.enterpriseId)
      formData.append('LoginToken', this.userinfo.loginToken)
      formData.append('ChannelId', this.form.ChannelId)
      formData.append('file', content.file)

      var self = this

      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post(this.constant.openPaths.importChannelOdd, formData, config).then(res => {
        if (res.data.code === 200) {
          var result = res.data.result
          switch (res.data.code) {
            case 200:
              self.$message({ message: res.data.msg, type: 'success' })
              self.search.pageindex = 1
              self.searchClick()
              self.dialogvisible = false
              break;
            case 402:
              self.$router.push({ name: 'login' })
              break
            default:
              self.$message.error(res.data.msg)
              break;
          }
        }
        else {
          self.$message.error(res.data.msg)
          content.onError(res.data.msg)
        }
      })
    },
    handleCommand (command) {
      switch (command) {
        case 'deleteChannelOdd':
        case 'useChannelOdd':
        case 'recoveryChannelOdd':
          {
            var data = {
              UserId: this.userinfo.id,
              EnterpriseId: this.userinfo.enterpriseId,
              LoginToken: this.userinfo.loginToken,
              OddIds: this.search.Odds
            }

            if (data.OddIds.length < 1) {
              this.$message.error('请选择要操作的单号')
              return
            }
            var url = ''
            if (command === 'deleteChannelOdd') {
              url = this.constant.openPaths.deleteChannelOdd
            } else if (command === 'useChannelOdd') {
              url = this.constant.openPaths.useChannelOdd
            } else {
              url = this.constant.openPaths.recoveryChannelOdd
            }
            var self = this
            this.$ajax.post(url, data).then(res => {
              switch (res.data.code) {
                case 200:
                  self.$message({ message: res.data.msg, type: 'success' })
                  self.searchClick()
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => { self.$message.error(error) })
          }
          break
        case 'importOddPool':
          this.dialogvisible = true
          break
        case 'exportChannelOdd':
          {
            var data = {
              UserId: this.userinfo.id,
              EnterpriseId: this.userinfo.enterpriseId,
              LoginToken: this.userinfo.loginToken,
              ChannelId: this.search.ChannelId,
              Odd: this.search.Odd,
              State: this.search.State,
              OddIds: this.search.Odds
            }
            if (this.search.ChannelId === undefined || this.search.ChannelId === null || this.search.ChannelId === '') {
              this.$message.error('导出号段请选择渠道')
              return
            }
            var self = this
            this.$ajax.post(this.constant.openPaths.exportChannelOdd, data).then(res => {
              switch (res.data.code) {
                case 200:
                  window.location.href = self.constant.openTmsUrl + res.data.result
                  break;
                case 402:
                  self.$router.push({ name: 'login' })
                  break
                default:
                  self.$message.error(res.data.msg)
                  break;
              }
            }).catch(error => { self.$message.error(error) })
          }
          break
        default:
          break
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/components/etms/tms/oddnum_manage.vue